import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getTeam ,formatDate } from '../../../../../utils/escaladeUtils';
import AddIcon from '@mui/icons-material/Add';
import Chip from '@mui/material/Chip';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import { Box, Typography } from "@mui/material";


// ─── Carte historique ─────────────────────────────────────────────
function HistoryCard({ item }) {
  const team   = getTeam(item.type);
  const isDone = item.dateFin !== null && item.dateFin !== undefined;

  return (
    <Box sx={{
      display: 'flex', gap: 1.5, alignItems: 'flex-start',
      p: 1.5, borderRadius: '10px',
      backgroundColor: isDone ? '#FAFAFA' : team.bg,
      border: `1px solid ${isDone ? '#e8e8e8' : team.border}`,
      opacity: isDone ? 0.75 : 1,
    }}>
      <Box sx={{
        width: 32, height: 32, borderRadius: '8px', flexShrink: 0,
        backgroundColor: isDone ? '#f0f0f0' : team.bg,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        border: `1px solid ${isDone ? '#ddd' : team.border}`,
      }}>
        {isDone
          ? <CheckCircleIcon sx={{ fontSize: 16, color: '#aaa' }} />
          : <NorthEastIcon   sx={{ fontSize: 16, color: team.color }} />}
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.25, flexWrap: 'wrap' }}>
          <Typography sx={{ fontSize: 13, fontWeight: 600, color: isDone ? '#666' : team.color }}>
            {team.label}
          </Typography>
          {item.numTicketDev && (
            <Chip label={`# ${item.numTicketDev}`} size="small"
              sx={{ fontSize: 10, height: 18, backgroundColor: '#E6F1FB', color: '#185FA5', fontWeight: 500 }} />
          )}
        </Box>

        {item.description && (
          <Typography sx={{ fontSize: 12, color: '#555', mb: 0.5, lineHeight: 1.4 }}>
            {item.description}
          </Typography>
        )}

        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Typography sx={{ fontSize: 11, color: '#999', display: 'flex', alignItems: 'center', gap: 0.4 }}>
            <AccessTimeIcon sx={{ fontSize: 12 }} /> Début : {formatDate(item.dateDebut)}
          </Typography>
          {isDone && (
            <Typography sx={{ fontSize: 11, color: '#999', display: 'flex', alignItems: 'center', gap: 0.4 }}>
              <CheckCircleIcon sx={{ fontSize: 12 }} /> Fin : {formatDate(item.dateFin)}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default HistoryCard;